import { render, staticRenderFns } from "./ProductsCategoriesCategory.vue?vue&type=template&id=5f9a944f&scoped=true&"
import script from "./ProductsCategoriesCategory.vue?vue&type=script&lang=js&"
export * from "./ProductsCategoriesCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCategoriesCategory.vue?vue&type=style&index=0&id=5f9a944f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9a944f",
  null
  
)

export default component.exports